import React, { FunctionComponent } from "react";
import logoNOL from "../../../assets/img/home/logo_NOL.png"
import "./footer.scss";


const Footer: FunctionComponent<{ props?: any }> = (props) => (
    <footer className="footer">
        <a href={(typeof window !== 'undefined' ? '//' + window.location.host : '/')} rel="noreferrer noopener" target="_blank" >
            <img src={logoNOL} alt='Logo NOL' />
        </a>

    </footer>
)
export default Footer;